import { lazy } from "react";
import { ALLOWED_MODULES } from "../../constants/enums";
import Loadable from "../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../router/AuthorizedRoute";

const PartnerWalletList = Loadable(
	lazy(() =>
		import("./PartnerWalletList").then(({ PartnerWalletList }) => ({
			default: PartnerWalletList,
		}))
	)
);

export const partnerWalletRoutes = [
	{
		path: "/partner-wallet",
		exact: true,
		element: (
			<AuthorizedRoute
				moduleIds={[ALLOWED_MODULES.CUSTOMER]}
			>
				<PartnerWalletList />
			</AuthorizedRoute>
		),
	},
];
